import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const Home = () => import("@/views/Home");
const Index = () => import("@/views/Index");
const About = () => import("@/views/About");
const HowItWork = () => import("@/views/HowItWork");
const FormVideo = () => import("@/views/FormVideo");
const ContactUs = () => import("@/views/ContactUs");
// Views

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

//App
const RegisterApp = () => import("@/views/RegisterApp");
const RegisterHomepage = () => import("@/views/RegisterHomepage");
const WhoAreYou = () => import("@/views/WhoAreYou");
const LoginNew = () => import("@/views/Login");
const InterviewerrVideo = () => import("@/views/InterviewerrVideo");
const Result = () => import("@/views/Result");
const Faq = () => import("@/views/FAQ");
const LoginAccount = () => import("@/views/LoginAccount");
const outh = () => import("@/views/outh");
const Blog = () => import("@/views/Blog");
const Legal = () => import("@/views/Legal");
const DashboardParticipant = () => import("@/views/DashboardParticipant");
const Profile = () => import("@/views/Profile");
const interest = () => import("@/views/SignUp");
const PlanIndividual = () => import("@/views/PlanIndividual");
const PlanCompany = () => import("@/views/PlanCompany");
const ListCandidate = () => import("@/views/ListCandidate");

const SubscribeCandidate = () => import('@/views/SubscribeCandidate')
const Recruitement = () => import('@/views/Recruitment')
const Dashboard = () => import('@/views/Dashboard')
const Setting = () => import('@/views/Setting')
const JoinUs = () => import('@/views/JoinUs')
const ForgotPassword = () => import('@/views/ForgotPassword')
const TestVideo = () => import('@/views/TestVideo')
const TestSetting = () => import('@/views/TestSetting')
const VerifyPassword = () => import('@/views/VerifyPassword')
const ResetPassword = () => import('@/views/ResetPassword')
const EditProfile = () => import('@/views/EditProfile')
const Receipt = () => import('@/views/Receipt')
const VerifyEmail = () => import('@/views/VerifyEmail')
const ConfirmationPackage = () => import('@/views/ConfirmationPackage')
const Payment = () => import('@/views/Payment')
const ManageVoucher = () => import('@/views/ManageVoucher')
const ManageBlog = () => import('@/views/ManageBlog')
const ManageCountries = () => import('@/views/ManageFlag')
const ManageContactUs = () => import('@/views/ManageContact')
const ManageUser = () => import('@/views/ManageUser')
const ManageSubscription = () => import('@/views/ManageSubscription')
const GenerateReport = () => import('@/views/GenerateReport')
const InterviewCandidateList = () => import('@/views/InterviewCandidateList')
const ShortlistedCandidate = () => import('@/views/ShortlistedCandidate')
const SuccessReceipt = () => import('@/views/SuccessReceipt')
const CancelPayment = () => import('@/views/CancelPayment')
const ReviewResume = () => import('@/views/ReviewResume')
const PortalJob = () => import('@/views/PortalJob')
const VideoList = () => import('@/views/VideoList')
const PreviewBlog = () => import('@/views/PreviewBlog')
const HomepageUser = () => import('@/views/Homepage')
const ManageApplicant = () => import('@/views/ManageApplicant')
const QR = () => import('@/views/QR')
const DirectInterview = () => import('@/views/DirectInterview')
const ManageQR = () => import('@/views/ManageQR')
const ManageQRJob = () => import('@/views/ManageQRJob')
const AskAI = () => import('@/views/AskAI')
const AnswerAI = () => import('@/views/AnswerAI')
const JobSeeker = () => import('@/views/JobSeeker')
// const VideoPlaylist = () => import('@/views/VideoPlaylist')
const Policy = () => import('@/views/Policy')
const CreativeInsight = () => import('@/views/CreativeInsight')
const ResultAI = () => import('@/views/ResultAI')
const CounterVisitor = () => import('@/views/CounterVisitor')
const ManageAccess = () => import('@/views/ManageAccess')
const ReportAI = () => import('@/views/ReportAI')
const AdminChat = () => import('@/views/AdminChat')
const HowItWorkCompany = () => import('@/views/HowItWorkCompany')
const HowItWorkCandidate = () => import('@/views/HowItWorkCandidate')
const TestChat = () => import('@/views/TestChat')
const ManageFeature = () => import('@/views/ManageFeature')
const ResumeCandidate = () => import('@/views/ResumeCandidate')
const ManageVoucherCompany = () => import('@/views/ManageVoucherCompany')
const OurProduct = () => import('@/views/OurProduct')
const Cart = () => import('@/views/Cart')
const DetailProduct = () => import('@/views/DetailProduct')
const Teachers = () => import('@/views/Teachers')
const SelectionTypeUser = () => import('@/views/SelectionTypeUser')
const SignUpParent = () => import('@/views/SignUpParent')
const LearningPort = () => import('@/views/LearningPort')
const Package = () => import('@/views/Package')
const ShoppingCart = () => import('@/views/ShoppingCart')
const StudentAchievement = () => import('@/views/StudentAchievement')
const ShoppingCart_test = () => import('@/views/ShoppingCart_test')
const PaymentFailed = () => import('@/views/PaymentFailed')
const PaymentSuccess = () => import('@/views/PaymentSuccess')
const Affiliate = () => import('@/views/Affiliate')
const RegisterAffiliate = () => import('@/views/RegisterAffiliate')
Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
      {
        path: '/',
        name: 'Index',
        component: Index, // Directly use Homepage component for root path
      },
      {
        path: '/',
        component: TheContainer,
      children: [
        {
          path: "SubscribeCandidate",
          name: "SubscribeCandidate",
          component: SubscribeCandidate,
        },
        {
          path: "Recruitment",
          name: "Recruitement",
          component: Recruitement,
        },
        {
          path: 'Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'Payment',
          name: 'Payment',
          component: Payment
        },
        {
          path: 'ManageVoucher',
          name: 'ManageVoucher',
          component: ManageVoucher
        },
        {
          path: 'ManageBlog',
          name: 'ManageBlog',
          component: ManageBlog
        },
        {
          path: 'ManageContact',
          name: 'ManageContact',
          component: ManageContactUs
        },
        {
          path: 'ManageUser',
          name: 'ManageUser',
          component: ManageUser
        },
        {
          path: 'ManageSubscription',
          name: 'ManageSubscription',
          component: ManageSubscription
        },
        {
          path: 'ManageApplicant',
          name: 'ManageApplicant',
          component: ManageApplicant
        },
        {
          path: 'ManageFlag',
          name: 'ManageCountries',
          component: ManageCountries
        },
        {
          path: 'ManageVoucherCompany',
          name: 'ManageVoucherCompany',
          component: ManageVoucherCompany
        },
        {
          path: 'GenerateReport',
          name: 'GenerateReport',
          component: GenerateReport
        },
        {
          path: 'InterviewCandidateList',
          name: 'InterviewCandidateList',
          component: InterviewCandidateList
        },
        {
          path: 'ShortlistedCandidate',
          name: 'ShortlistedCandidate',
          component: ShortlistedCandidate
        },
        {
          path: 'VideoList',
          name: 'VideoList',
          component: VideoList
        },
        {
          path: 'ManageAccess',
          name: 'ManageAccess',
          component: ManageAccess
        },
        {
          path: 'ManageQR',
          name: 'ManageQR',
          component: ManageQR
        },
        {
          path: 'ManageQRJob',
          name: 'ManageQRJob',
          component: ManageQRJob
        },
        {
          path: 'AskAI',
          name: 'AskAI',
          component: AskAI
        },
        {
          path: 'AnswerAI',
          name: 'AnswerAI',
          component: AnswerAI
        },
        {
          path: 'JobSeeker',
          name: 'JobSeeker',
          component: JobSeeker
        },
        {
          path: 'CounterVisitor',
          name: 'CounterVisitor',
          component: CounterVisitor
        },
        {
          path: 'HowItWorkCompany',
          name: 'HowItWorkCompany',
          component: HowItWorkCompany
        },
        {
          path: 'ManageFeature',
          name: 'ManageFeature',
          component: ManageFeature
        },
       
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },

        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          name: "CoreUI Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },

    {
      path: "/",
      redirect: "/home",
      name: "Home",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "home",
          name: "home",
          component: Home,
        },
      ],
    },

    {
      path: "/",
      redirect: "/Index",
      name: "Index",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Index",
          name: "Index",
          component: Index,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "About",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "About",
          name: "About",
          component: About,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "HowItWork",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "HowItWork",
          name: "HowItWork",
          component: HowItWork,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "FormVideo",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "FormVideo",
          name: "FormVideo",
          component: FormVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ContactUs",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ContactUs",
          name: "ContactUs",
          component: ContactUs,
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      name: "RegisterApp",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "RegisterApp",
          name: "RegisterApp",
          component: RegisterApp,
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      name: "RegisterHomepage",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "RegisterHomepage",
          name: "RegisterHomepage",
          component: RegisterHomepage,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "WhoAreYou",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "WhoAreYou",
          name: "WhoAreYou",
          component: WhoAreYou,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Login",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Login",
          name: "Login",
          component: LoginNew,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "InterviewerrVideo",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "InterviewerrVideo",
          name: "InterviewerrVideo",
          component: InterviewerrVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Result",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Result",
          name: "Result",
          component: Result,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Faq",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Faq",
          name: "Faq",
          component: Faq,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "LoginAccount",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "LoginAccount",
          name: "LoginAccount",
          component: LoginAccount,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "outh",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "outh",
          name: "outh",
          component: outh,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Blog",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Blog",
          name: "Blog",
          component: Blog,
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      name: "Legal",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Legal",
          name: "Legal",
          component: Legal,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "DashboardParticipant",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "DashboardParticipant",
          name: "DashboardParticipant",
          component: DashboardParticipant,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Profile",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Profile",
          name: "Profile",
          component: Profile,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "interest",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "signup",
          name: "interest",
          component: interest,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PlanIndividual",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PlanIndividual",
          name: "PlanIndividual",
          component: PlanIndividual,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PlanCompany",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PlanCompany",
          name: "PlanCompany",
          component: PlanCompany,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ListCandidate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ListCandidate",
          name: "ListCandidate",
          component: ListCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "JoinUs",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "JoinUs",
          name: "JoinUs",
          component: JoinUs,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ForgotPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ForgotPassword",
          name: "ForgotPassword",
          component: ForgotPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "VerifyPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "VerifyPassword",
          name: "VerifyPassword",
          component: VerifyPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "TestVideo",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "TestVideo",
          name: "TestVideo",
          component: TestVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "TestSetting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "TestSetting",
          name: "TestSetting",
          component: TestSetting,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ResetPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ResetPassword",
          name: "ResetPassword",
          component: ResetPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "EditProfile",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "EditProfile",
          name: "EditProfile",
          component: EditProfile,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Receipt",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Receipt",
          name: "Receipt",
          component: Receipt,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "SuccessReceipt",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "SuccessReceipt",
          name: "SuccessReceipt",
          component: SuccessReceipt,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "CancelPayment",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "CancelPayment",
          name: "CancelPayment",
          component: CancelPayment,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "VerifyEmail",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "VerifyEmail",
          name: "VerifyEmail",
          component: VerifyEmail,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ConfirmationPackage",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ConfirmationPackage",
          name: "ConfirmationPackage",
          component: ConfirmationPackage,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ReviewResume",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ReviewResume",
          name: "ReviewResume",
          component: ReviewResume,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PortalJob",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PortalJob",
          name: "PortalJob",
          component: PortalJob,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PreviewBlog",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PreviewBlog",
          name: "PreviewBlog",
          component: PreviewBlog,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "HomepageUser",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Homepage",
          name: "Homepage",
          component: HomepageUser,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "QR",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "QR",
          name: "QR",
          component: QR,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "DirectInterview",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "DirectInterview",
          name: "DirectInterview",
          component: DirectInterview,
        },
      ],
    },
    // {
    //   path: "/",
    //   redirect: "/",
    //   name: "VideoPlaylist",
    //   component: {
    //     render(c) {
    //       return c("router-view");
    //     },
    //   },
    //   children: [
    //     {
    //       path: "VideoPlaylist",
    //       name: "VideoPlaylist",
    //       component: VideoPlaylist,
    //     },
    //   ],
    // },
    {
      path: "/",
      redirect: "/",
      name: "Policy",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Policy",
          name: "Policy",
          component: Policy,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "CreativeInsight",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "CreativeInsight",
          name: "CreativeInsight",
          component: CreativeInsight,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ResultAI",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ResultAI",
          name: "ResultAI",
          component: ResultAI,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ReportAI",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ReportAI",
          name: "ReportAI",
          component: ReportAI,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "AdminChat",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "AdminChat",
          name: "AdminChat",
          component: AdminChat,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "HowItWorkCandidate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "HowItWorkCandidate",
          name: "HowItWorkCandidate",
          component: HowItWorkCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "TestChat",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "TestChat",
          name: "TestChat",
          component: TestChat,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ResumeCandidate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ResumeCandidate",
          name: "ResumeCandidate",
          component: ResumeCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "OurProduct",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "OurProduct",
          name: "OurProduct",
          component: OurProduct,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Cart",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Cart",
          name: "Cart",
          component: Cart,
        },
      ],
    },
    {
          path: '/DetailProduct/:id',
          name: "DetailProduct",
          component: DetailProduct,
      
    },
    {
      path: "/",
      redirect: "/",
      name: "Teachers",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Teachers",
          name: "Teachers",
          component: Teachers,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "SelectionTypeUser",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "SelectionTypeUser",
          name: "SelectionTypeUser",
          component: SelectionTypeUser,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "SignUpParent",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "SignUpParent",
          name: "SignUpParent",
          component: SignUpParent,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "LearningPort",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "LearningPort",
          name: "LearningPort",
          component: LearningPort,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Package",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Package",
          name: "Package",
          component: Package,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ShoppingCart",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ShoppingCart",
          name: "ShoppingCart",
          component: ShoppingCart,
        },
      ],
    },
     {
      path: "/",
      redirect: "/",
      name: "StudentAchievement",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "StudentAchievement",
          name: "StudentAchievement",
          component: StudentAchievement,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ShoppingCart_test",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ShoppingCart_test",
          name: "ShoppingCart_test",
          component: ShoppingCart_test,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PaymentFailed",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PaymentFailed",
          name: "PaymentFailed",
          component: PaymentFailed,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "PaymentSuccess",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "PaymentSuccess",
          name: "PaymentSuccess",
          component: PaymentSuccess,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Affiliate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Affiliate",
          name: "Affiliate",
          component: Affiliate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "RegisterAffiliate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "RegisterAffiliate",
          name: "RegisterAffiliate",
          component: RegisterAffiliate,
        },
      ],
    },
  
    
  ];
}
